import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";

const GetLeadsIncludesInArray = async (leadsIds = []) => {
  /**
   * input: null
   * output: leads object
   * description: fetches All leads
   */

  try {
    let dataToReturn = [];
    for (let index = 0; index < leadsIds.length; index++) {
      const leadsDoc = doc(db, "leads", leadsIds[index]);

      const leadsSnapshot = await getDoc(leadsDoc);
      dataToReturn.push({ ...leadsSnapshot.data(), id: leadsSnapshot.id });
    }

    return dataToReturn;
  } catch (error) {
    console.log(error);
  }
};

export default GetLeadsIncludesInArray;
